import axios from "../axios";
const endPoint = `/sizes`

export const getsizes = async (subcategory) => {
    return await axios.get(`${endPoint}/sub_category/${subcategory}`)
}